import Modal from "./Modal.vue";
import mixin from "./mixin";

export const modalMixin = mixin;

export default Modal;
